var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-loader u-bg-grey-light"},[_c('div',{staticClass:"app-loader__bar u-bg-white u-w8of8 t-translate__right-enter-active",style:({transform: ("scaleX(" + _vm.load + ") translateZ(0)")})})])}
var staticRenderFns = []

export { render, staticRenderFns }